<div class="menu-img" >
  <ion-img src="assets/images/menu.svg"></ion-img>
</div>